import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { hasAccess } from "lib/constants/access-keys";
import { getVisibleMenuItems } from "components/layout/Sidebar";

export default function AccessRoute({ requires, children, ...rest }) {
  const userAccess = useSelector((state) => state.session.user?.access ?? []);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (requires && !hasAccess(userAccess, requires)) {
          const visible = getVisibleMenuItems(userAccess);
          const fallback = visible[0]?.path ?? "/portal/no-access";
          return <Redirect to={fallback} />;
        }
        return typeof children === "function" ? children(props) : children;
      }}
    />
  );
}
